module.exports = __webpack_public_path__ + "assets/img/comp_2.91d3c921.png";